import request from "@/utils/interceptor.js";


export function getMentalState(params) {
  return request({
    url: "/api/pas/mshas-report-data/mshas-report-data-statistics",
    method: "get",
    params,
  });
}
/**
 * 查询城市
 * @param {Object} params
 * @param {string} [params.code] 传入orgAddress查询地址
 * @param {string} [params.organizationId] 组织ID（左侧组织树选中节点）
 */
export function	dictdataapp(params){
		return request({
			url: `/api/testerapp/dictdataapp/organizationlist`,
			method: 'get',
			params,
		})
}